'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
    min-height: 100vh;
    overflow: hidden;
    
    ${(commonStyle == null ? void 0 : commonStyle.backgroundOverlay) ? "z-index: 0;" : ""}
    ${coreRenderer.getStyle(commonStyle)};
  `
);
const Root = (props) => {
  const { device } = coreRenderer.useStore();
  const newProps = coreRenderer.getPropsByDevice(props, device);
  const { children, commonStyle } = newProps;
  return /* @__PURE__ */ jsxRuntime.jsx(coreRenderer.BreakpointWidthProvider, {
    sWidth: { value: 100, unit: "%" },
    mWidth: { value: 100, unit: "%" },
    children: /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
      commonStyle,
      children
    })
  });
};
Root.displayName = "Root";

exports.Root = Root;
